import React from "react";

/**
 * Label + control + inline error. Pass the input as `children`, or use the default
 * text input via `name`/`value`/`onChange`.
 */
export default function FormField({
  label,
  required = false,
  error,
  className = "",
  children,
  ...inputProps
}) {
  const id = inputProps.id ?? inputProps.name;
  return (
    <div className={`form-group mst-field ${className}`}>
      {label && (
        <label htmlFor={id}>
          {label}
          {required && <span className="text-danger">*</span>}
        </label>
      )}
      {children ?? (
        <input
          id={id}
          type="text"
          className={`form-control form-control-sm${error ? " is-invalid" : ""}`}
          {...inputProps}
        />
      )}
      {error && <span className="invalid-feedback">{error}</span>}
    </div>
  );
}

/** Bootstrap checkbox with label. */
export function CheckField({ label, name, checked, onChange, className = "" }) {
  return (
    <div className={`form-group form-check ${className}`}>
      <input
        className="form-check-input"
        type="checkbox"
        id={name}
        name={name}
        checked={Boolean(checked)}
        onChange={onChange}
      />
      <label className="form-check-label" htmlFor={name}>
        {label}
      </label>
    </div>
  );
}
